export const cardArray = [
  {
    id: 1,
    name: "Credit Card",
    value: "credit",
  },
  // {
  //   id: 2,
  //   name: "EFT (Electronic Funds Transfer)",
  //   value: "eft",
  // },
];

export const accountArray = [
  {
    id: 1,
    name: "Checking Account",
  },
  {
    id: 2,
    name: "Savings Account",
  },
];
